module.exports = __webpack_public_path__ + "static/assets/899f0489637834bdd081688e8999e598.svg";